import classNames from 'classnames'
import { useRef } from 'react'

import type { AgGridReact } from 'ag-grid-react'
import type { ReactElement } from 'react'
import type { MobileDeviceType } from '~/types/device-type'

import columns from './columns'

import ContentLayout from '~/components/ContentLayout'
import Layout from '~/components/Layouts/Layout'
import Section from '~/components/Section'
import TableWrapper from '~/components/Tables/TableWrapper'
import ViewTitle from '~/components/ViewTitle'
import useDocumentTitle from '~/hooks/useDocumentTitle'
import { useRecommendedClustersListQuery, useRecommendedClusterMutation } from '~/queries/clusters'
import { handleGenericError } from '~/utils/error'
import { displayToast } from '~/utils/toast'

import './styles.scss'

const ENTRIES_NAME = 'recommendations'

const CompetitorsRecommendations = (): ReactElement => {
  /** Local state */

  const gridRef = useRef<AgGridReact>(null)

  /** Queries & Mutations */

  const { data: recommendedList, isFetching } = useRecommendedClustersListQuery({ size: 100 })

  const { mutateAsync: setRecommendedClusters } = useRecommendedClusterMutation()

  const rowData = recommendedList?.data || []

  /** Handlers */

  const handleDecisionCheckboxChange = async (
    deviceType: MobileDeviceType,
    storeId: string,
    status: string,
    clusterId?: string
  ) => {
    try {
      await setRecommendedClusters({ clusterId, deviceType, status, storeId })
      displayToast(`App successfully ${status} for cluster`, 'success')
    } catch (e) {
      handleGenericError(e)
    }
  }

  /** Effects */

  useDocumentTitle('Competitors - Recommendations')

  return (
    <>
      <ViewTitle className="layout-view-title">Cluster recommendations</ViewTitle>
      <Layout className="recommendations-view" withPadding>
        <ContentLayout>
          <Section className="section">
            <TableWrapper
              className={classNames('recommendations-table', { 'recommendations-table--loading': isFetching })}
              columnDefs={columns}
              context={{ onDecisionCheckboxChange: handleDecisionCheckboxChange }}
              enableCellTextSelection
              entriesName={ENTRIES_NAME}
              ref={gridRef}
              rowData={rowData}
              rowHeight={250}
              rowStyle={{ cursor: 'default' }}
              withPagination={false}
            />
          </Section>
        </ContentLayout>
      </Layout>
    </>
  )
}

export default CompetitorsRecommendations
